export enum PaymentSectionContainerHook {
  Payment_Section = 'payment-section',
}
